import * as Yup from "yup";

export function initialValues(paymentCategory) {
  return {
    name: paymentCategory?.name || "",
    status: paymentCategory?.status || true,
  };
}

export function validationSchema() {
  return Yup.object({
    name: Yup.string().required("El nombre es obligatorio"),
    status: Yup.boolean().required(true),
  });
}
